// Pairs well with v2 -- Complete Health
// Checkbox + variant-dropdown state, live total, dims the matching thumbnail in the image row
// when its line is unchecked or sold out, single /cart/add.js call for every checked line, then
// opens the theme's cart drawer (falls back to /cart).
(function () {
  'use strict';

  // Mirrors Shopify's `money` Liquid filter so client-side totals match server-rendered prices
  // exactly (this shop's format includes a " USD" suffix, which Intl currency formatting drops).
  function formatMoney(cents, format) {
    var amount = Number(cents) || 0;
    var noDecimals = String(Math.round(amount / 100));
    var withDecimals = (amount / 100).toFixed(2);
    var placeholders = {
      amount: withDecimals.replace(/\B(?=(\d{3})+(?!\d))/g, ','),
      amount_no_decimals: noDecimals.replace(/\B(?=(\d{3})+(?!\d))/g, ','),
      amount_with_comma_separator: withDecimals.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.').replace(/\.(\d{2})$/, ',$1').replace(/(\d)(?=(\d{3})+,)/g, '$1.'),
      amount_no_decimals_with_comma_separator: noDecimals.replace(/\B(?=(\d{3})+(?!\d))/g, '.'),
      amount_with_apostrophe_separator: withDecimals.replace(/\B(?=(\d{3})+(?!\d))/g, "'")
    };
    var template = format || '${{amount}}';
    return template.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, key) {
      return placeholders[key] !== undefined ? placeholders[key] : withDecimals;
    });
  }

  function initSection(root) {
    var moneyFormat = root.getAttribute('data-money-format') || '${{amount}}';
    var lines = Array.prototype.slice.call(root.querySelectorAll('[data-pwx-line]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-pwx-thumb]'));
    var totalEl = root.querySelector('[data-pwx-total]');
    var totalWasEl = root.querySelector('[data-pwx-total-was]');
    // Bundle discount on eligible add-ons (display-only: must match the live "PWW Bundle"
    // discounts). Shown inside each add-on's own price; there is no separate savings line.
    var bundlePercent = Math.max(0, Math.min(100, Number(root.getAttribute('data-bundle-percent')) || 0));
    var addBtn = root.querySelector('[data-pwx-add-to-cart]');
    var statusEl = root.querySelector('[data-pwx-status]');

    function thumbFor(index) {
      return thumbs.filter(function (t) { return t.getAttribute('data-line-index') === String(index); })[0];
    }

    function lineState(line) {
      var checkbox = line.querySelector('[data-pwx-checkbox]');
      var select = line.querySelector('[data-pwx-variant-select]');
      var priceEl = line.querySelector('[data-pwx-price]');
      var variantsScript = line.querySelector('[data-pwx-variants]');
      var variants = [];
      try { variants = JSON.parse(variantsScript.textContent); } catch (e) { variants = []; }
      var index = line.getAttribute('data-line-index');
      return { line: line, checkbox: checkbox, select: select, priceEl: priceEl, variants: variants, thumb: thumbFor(index), isAddon: index !== '0', productId: line.getAttribute('data-product-id'), bundleEligible: line.getAttribute('data-bundle-eligible') === 'true' };
    }

    var states = lines.map(lineState);

    function currentVariant(state) {
      if (state.select) {
        var id = Number(state.select.value);
        var found = state.variants.filter(function (v) { return v.id === id; })[0];
        if (found) return found;
      }
      return state.variants[0];
    }

    function updateThumb(state) {
      if (!state.thumb) return;
      var dim = !(state.checkbox && state.checkbox.checked && !state.checkbox.disabled);
      state.thumb.classList.toggle('pairs-well-with__thumb--dim', dim);
    }

    function updateLineDisabled(state) {
      var v = currentVariant(state);
      var soldOut = v && !v.available;
      state.line.classList.toggle('pairs-well-with__row--disabled', !!soldOut);
      if (soldOut && state.checkbox) {
        state.checkbox.checked = false;
        state.checkbox.disabled = true;
      } else if (state.checkbox) {
        state.checkbox.disabled = false;
      }
      updateThumb(state);
    }

    // Price the cart will charge for this variant after the bucket discount (resolved server-side
    // by the theme's sale-badge-resolve snippet). Falls back to the regular price.
    function salePrice(v) {
      var sale = Number(v.sale);
      var price = Number(v.price) || 0;
      return sale > 0 && sale < price ? sale : price;
    }

    // What the cart will charge for this line: the bucket price, and for an eligible add-on the
    // bucket price less the bundle %, rounded the way the PWW Bundle discounts are set:
    // round(bucket price x (100 - pct) / 100).
    function payPrice(state, v) {
      var sp = salePrice(v);
      if (state.isAddon && state.bundleEligible && bundlePercent > 0) {
        return Math.round(sp * (100 - bundlePercent) / 100);
      }
      return sp;
    }

    function updatePrice(state) {
      var v = currentVariant(state);
      if (!v || !state.priceEl) return;
      var price = Number(v.price) || 0;
      var sale = payPrice(state, v);
      state.priceEl.setAttribute('data-price', sale);
      state.priceEl.textContent = '';
      if (sale < price) {
        var was = document.createElement('s');
        was.className = 'pairs-well-with__was';
        was.textContent = formatMoney(price, moneyFormat);
        var now = document.createElement('span');
        now.className = 'pairs-well-with__now pairs-well-with__now--sale';
        now.textContent = formatMoney(sale, moneyFormat);
        state.priceEl.appendChild(was);
        state.priceEl.appendChild(now);
      } else {
        var only = document.createElement('span');
        only.className = 'pairs-well-with__now';
        only.textContent = formatMoney(price, moneyFormat);
        state.priceEl.appendChild(only);
      }
    }

    function recomputeTotal() {
      var full = 0;
      var total = 0;
      states.forEach(function (state) {
        if (state.checkbox && state.checkbox.checked && !state.checkbox.disabled) {
          var v = currentVariant(state);
          if (v) {
            full += Number(v.price) || 0;
            total += payPrice(state, v);
          }
        }
        updateThumb(state);
      });
      if (totalWasEl) {
        totalWasEl.hidden = !(full > total);
        totalWasEl.textContent = formatMoney(full, moneyFormat);
      }
      if (totalEl) totalEl.textContent = formatMoney(total, moneyFormat);
      if (addBtn) {
        var anyChecked = states.some(function (s) { return s.checkbox && s.checkbox.checked && !s.checkbox.disabled; });
        addBtn.disabled = !anyChecked;
      }
    }

    states.forEach(function (state) {
      updateLineDisabled(state);
      updatePrice(state);
      if (state.checkbox) {
        state.checkbox.addEventListener('change', recomputeTotal);
      }
      if (state.select) {
        state.select.addEventListener('change', function () {
          updateLineDisabled(state);
          updatePrice(state);
          recomputeTotal();
        });
      }
    });

    recomputeTotal();

    function setStatus(text, stateName) {
      if (!statusEl) return;
      statusEl.textContent = text || '';
      if (stateName) {
        statusEl.setAttribute('data-pwx-status-state', stateName);
      } else {
        statusEl.removeAttribute('data-pwx-status-state');
      }
    }

    function openCartDrawer(parsedState) {
      // This theme's cart-drawer.js (Dawn-derived) expects renderContents(parsedState) where
      // parsedState.sections['cart-drawer'] / ['cart-icon-bubble'] are rendered section HTML,
      // which only exists when the /cart/add.js POST itself asked for those sections.
      var drawer = document.querySelector('cart-drawer');
      try {
        if (drawer && parsedState && parsedState.sections && typeof drawer.renderContents === 'function') {
          drawer.renderContents(parsedState);
          return true;
        }
        if (drawer && typeof drawer.open === 'function') {
          drawer.open();
          return true;
        }
      } catch (e) { return false; }
      return false;
    }

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var items = [];
        states.forEach(function (state) {
          if (state.checkbox && state.checkbox.checked && !state.checkbox.disabled) {
            var v = currentVariant(state);
            if (v) {
              // Hidden line properties: _pww marks every line added from this box, _pww_addon marks
              // the add-ons. The "PWW Bundle" automatic discounts key on _pww_addon.
              var props = { _pww: '1' };
              // Value = product ID: each "PWW Bundle" discount matches _pww_addon = its product's ID.
              if (state.isAddon && state.productId) props._pww_addon = String(state.productId);
              items.push({ id: v.id, quantity: 1, properties: props });
            }
          }
        });

        if (!items.length) {
          setStatus('Select at least one item.', 'error');
          return;
        }

        addBtn.disabled = true;
        setStatus('Adding...');

        var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';
        var body = JSON.stringify({
          items: items,
          sections: ['cart-drawer', 'cart-icon-bubble'],
          sections_url: window.location.pathname
        });

        fetch(addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: body
        })
          .then(function (res) {
            if (!res.ok) return res.json().then(function (err) { throw err; });
            return res.json();
          })
          .then(function (parsedState) {
            setStatus('Added to cart.', 'ok');
            var opened = openCartDrawer(parsedState);
            if (!opened) {
              window.location.href = '/cart';
            }
          })
          .catch(function (err) {
            var msg = (err && err.description) || 'Could not add to cart.';
            setStatus(msg, 'error');
          })
          .finally(function () {
            recomputeTotal();
          });
      });
    }
  }

  function init() {
    document.querySelectorAll('.pairs-well-with').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


/* Thumbnails: transparent-background product shots, no white backdrops.
   File type does not tell us (a .webp can be transparent, a .png can be flat), so check the
   actual pixels: for each thumb, try its product images in order and use the first one whose
   corners are transparent. If a product has none, keep its featured image and blend its white
   backdrop into the page (pairs-well-with__thumb--flat). */
(function () {
  /* Resolves {ok, box} where ok = corners are transparent and box = the product's visible
     bounds as fractions of the image, used to scale every thumb to the same visual size. */
  function isTransparent(url) {
    return new Promise(function (resolve) {
      var im = new Image();
      im.crossOrigin = 'anonymous';
      im.onload = function () {
        try {
          var N = 64, c = document.createElement('canvas');
          c.width = N; c.height = N;
          var x = c.getContext('2d');
          x.drawImage(im, 0, 0, N, N);
          var d = x.getImageData(0, 0, N, N).data;
          var corners = [0, N - 1, N * (N - 1), N * N - 1];
          var ok = corners.every(function (i) { return d[i * 4 + 3] < 20; });
          var minX = N, minY = N, maxX = -1, maxY = -1;
          if (ok) {
            for (var y = 0; y < N; y++) for (var xx = 0; xx < N; xx++) {
              if (d[(y * N + xx) * 4 + 3] > 120) {
                if (xx < minX) minX = xx; if (xx > maxX) maxX = xx;
                if (y < minY) minY = y; if (y > maxY) maxY = y;
              }
            }
          }
          var box = maxX >= 0 ? { x: minX / N, y: minY / N, w: (maxX - minX + 1) / N, h: (maxY - minY + 1) / N } : null;
          resolve({ ok: ok, box: box });
        } catch (e) { resolve({ ok: false, box: null }); }
      };
      im.onerror = function () { resolve({ ok: false, box: null }); };
      im.src = url;
    });
  }

  /* Zoom the image so the product (not its padding) fills the same share of every thumb */
  function fit(img, box) {
    if (!box) { img.style.transform = ''; return; }
    var s = Math.min(0.92 / box.w, 0.92 / box.h, 2.2);
    var cx = (box.x + box.w / 2 - 0.5) * 100, cy = (box.y + box.h / 2 - 0.5) * 100;
    img.style.transform = 'scale(' + s.toFixed(3) + ') translate(' + (-cx).toFixed(2) + '%,' + (-cy).toFixed(2) + '%)';
  }

  function norm(s) { return (s || '').toLowerCase().replace(/[^a-z0-9]/g, ''); }

  /* Prefer a transparent shot of the flavor that is actually selected in this row */
  function flavorFor(thumb) {
    var idx = thumb.getAttribute('data-line-index');
    var root = thumb.closest('.pairs-well-with');
    var row = root && root.querySelector('[data-pwx-line][data-line-index="' + idx + '"]');
    var sel = row && row.querySelector('[data-pwx-variant-select]');
    if (!sel || !sel.options[sel.selectedIndex]) return '';
    return norm(sel.options[sel.selectedIndex].text.split('/')[0].replace(/\(sold out\)/i, ''));
  }

  function pick(img) {
    var thumb = img.closest('.pairs-well-with__thumb');
    var all = (img.getAttribute('data-pwx-cands') || '').split('|').filter(Boolean);
    var flavor = flavorFor(thumb);
    var file = function (u) { return norm(u.split('/').pop().split('?')[0]); };
    var cands = flavor
      ? all.filter(function (u) { return file(u).indexOf(flavor) > -1; })
          .concat(all.filter(function (u) { return file(u).indexOf(flavor) === -1; }))
      : all;
    var i = 0;
    function done() { thumb.classList.add('pairs-well-with__thumb--ready'); }
    function next() {
      if (i >= cands.length) {
        /* No transparent shot: use the selected flavor's photo if there is one, blended into the page */
        if (flavor && cands[0] && file(cands[0]).indexOf(flavor) > -1) img.src = cands[0];
        fit(img, null);
        thumb.classList.add('pairs-well-with__thumb--flat'); done(); return;
      }
      var u = cands[i++];
      isTransparent(u).then(function (r) {
        if (r.ok) { img.src = u; fit(img, r.box); thumb.classList.remove('pairs-well-with__thumb--flat'); done(); } else { next(); }
      });
    }
    setTimeout(done, 2500);
    next();
  }

  function run() {
    document.querySelectorAll('.pairs-well-with__thumb img[data-pwx-cands]').forEach(pick);
    document.querySelectorAll('.pairs-well-with [data-pwx-variant-select]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var row = sel.closest('[data-pwx-line]');
        var root = sel.closest('.pairs-well-with');
        var img = row && root && root.querySelector('.pairs-well-with__thumb[data-line-index="' + row.getAttribute('data-line-index') + '"] img[data-pwx-cands]');
        if (img) pick(img);
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
